import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { CvNumberLocalizePipe } from 'src/app/reusables/pipes/cv-number-localize.pipe';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { GamificationMainService } from 'src/app/gamification/command-center/services/gamification-main.service';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    selector: 'cv-coin-history',
    templateUrl: './coin-history.component.html',
    styleUrls: ['./coin-history.component.scss']
})
export class CoinHistoryComponent implements OnInit, OnChanges {
    @Input() overviewDate: any;
    @ViewChild(BaseChartDirective) chartObject: BaseChartDirective;

    gms = null;

    //Chart variables
    chartConfig = null;
    labels = [];
    spentCoins = [];
    awardedCoins = [];

    firstAnimateComplete = false;
    isDestroyed = false;
    localization = new Map();
    totalAvailableCoins = '--';

    constructor(
        private cvNumberLocalizePipe: CvNumberLocalizePipe,
        private cvLocalizationService: CVLocalizationService,
        private gamificationMainService: GamificationMainService
    ) {
        this.gms = this.gamificationMainService.data;
        $(document).on('event_SelectedGroupsChanged', this.onGroupsChangedHandler);
    }

    ngOnInit(): void {
        this.loadLocalization();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.overviewDate && changes.overviewDate.previousValue !== changes.overviewDate.currentValue) {
            this.gms.settings.OverviewDate = changes.overviewDate.currentValue;
            this.loadCoinHistory();
        }
    }

    loadLocalization(): void {
        this.cvLocalizationService.GetSection("Gamification_Admin").then((map) => {
            this.localization = map;
            this.loadCoinHistory();
        });
    }

    loadCoinHistory(): void {
        this.gamificationMainService.loadTotalAvailableCoins().then((result) => {
            this.totalAvailableCoins = this.cvNumberLocalizePipe.transform(this.gms.totalAvailableCoins);
        });

        this.gamificationMainService.loadCoinHistory(this.gms.settings.OverviewDate).then(() => {
            this.labels = [];
            this.spentCoins = [];
            this.awardedCoins = [];

            angular.forEach(this.gms.coinHistory, (coinHistoryItem, label: string) => {
                this.labels.push(this.getLocalizedText(label, label));
                // Chart.js requires numeric dataset values. Localize values only when displaying them.
                this.spentCoins.push(coinHistoryItem.CoinsSpent);
                this.awardedCoins.push(coinHistoryItem.CoinsAwarded);
            });

            this.createChart();

        });
    };

    createChart(): void {
        //Check for empty datasets
        if (this.spentCoins === null && this.awardedCoins === null) {
            return;
        }

        this.chartConfig = {
            type: 'bar',
            data: {
                datasets: [{
                    label: this.getLocalizedText('Coins_Spent_Column', 'Coins Spent'),
                    data: [],
                    type: 'line',
                    fill: false,
                    borderColor: '#353A40',
                    backgroundColor: '#353A40',
                    pointBackgroundColor: '#353A40',
                    pointBorderColor: '#353A40',
                    borderWidth: 2,
                }, {
                    label: this.getLocalizedText('Coins_Awarded', 'Coins Awarded'),
                    data: [],
                    backgroundColor: 'rgba(217, 217, 217, 1)',
                }],
                labels: this.labels,
            },
            options: {
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: ctx => `${ctx.dataset.label}: ${this.cvNumberLocalizePipe.transform(ctx.parsed.y)}`,
                            labelColor: ctx => ({
                                borderColor: 'rgba(255,255,255)',
                                backgroundColor: ctx.dataset.backgroundColor,
                            })
                        },
                    },
                },
                animation: {
                    duration: (this.firstAnimateComplete) ? 0 : 1000
                },
                responsive: true,
                maintainAspectRadio: false,
                scales: {
                    y: {
                        ticks: {
                            stepSize: 100000,
                            callback: (value) => this.cvNumberLocalizePipe.transform(value),
                        }
                    }
                }
            }
        } as ChartConfiguration;
        this.firstAnimateComplete = true;
        this.updateChart();
    }

    updateChart(): void {
        this.chartConfig.data.datasets[0].data = this.labels.map((label, index) => ({
            x: label,
            y: this.spentCoins[index],
        }));
        this.chartConfig.data.datasets[1].data = this.labels.map((label, index) => ({
            x: label,
            y: this.awardedCoins[index],
        }));
        this.chartConfig.data.labels = this.labels;
    }

    getLocalizedText(key: string, defaultValue: string): string {
        if (this.localization && this.localization.has(key)) {
            return this.localization.get(key);
        }
        else { return defaultValue; }
    }

    onGroupsChanged(e: any): void {
        if (!this.chartObject?.chart) {
            return;
        }

        this.loadCoinHistory();
    }

    private onGroupsChangedHandler = (e: any) => this.onGroupsChanged(e);
}